import { createContext, useContext, useState, type ReactNode } from "react";
import { useActivityFlow } from "@hooks/useActivityFlow";
import type { AppStep } from "@app-types/navigation.types";

type ActivityFlow = ReturnType<typeof useActivityFlow>;

const ActivityFlowContext = createContext<ActivityFlow | undefined>(undefined);

export const ActivityFlowProvider = ({ children }: { children: ReactNode }) => {
  const [currentStep, setCurrentStep] = useState<AppStep>(0);
  const flow = useActivityFlow(currentStep, setCurrentStep);

  return (
    <ActivityFlowContext.Provider value={flow}>
      {children}
    </ActivityFlowContext.Provider>
  );
};

export const useActivityFlowContext = () => {
  const flow = useContext(ActivityFlowContext);

  if (!flow) {
    throw new Error(
      "useActivityFlowContext must be used within ActivityFlowProvider",
    );
  }

  return flow;
};
